import React from 'react';
import PropTypes from 'prop-types';
import useSelectFile from 'components/hooks/useSelectFile';
import TextButtonField from 'components/pages/ResourceSetting/Widgets/TextButtonField';
// import Styles from './index.module.css';

export default function SingleImageUploadField({
  value,
  onChange,
  required,
  disabled,
}) {
  const { openFilePrompt } = useSelectFile();
  const handleClick = () => {
    if (value) onChange();
    else openFilePrompt().then((files) => onChange((files || [])[0]));
  };

  return (
    <TextButtonField
      title="圖片上傳"
      description="建議提供圖片，限制1200X628像素"
      buttonText="瀏覽檔案"
      value={value}
      onClick={handleClick}
      required={required}
      disabled={disabled}
    />
  );
}

SingleImageUploadField.propTypes = {
  value: PropTypes.string,
  onChange: PropTypes.func,
  disabled: PropTypes.bool,
  required: PropTypes.bool,
};

SingleImageUploadField.defaultProps = {
  value: '',
  onChange: () => {},
  disabled: false,
  required: true,
};
